import { PriceCompareMessage } from '../../../../types/PriceCompareMessage';
import { VesselMessage } from '../../../../types/VesselMessage';
import { getPriceCompare } from '../../../common/api/clients/gateway.api';

import { useEnhancedSchedule } from './useEnhancedSchedule';

export const useSchedulesWithPrices = (vessel: VesselMessage) => {
    return useEnhancedSchedule<PriceCompareMessage>(vessel, async (vesselId: string, portIds: string[]) =>
        portIds.length ? getPriceCompare(vesselId, portIds).then((compareMessage) => compareMessage.prices) : []
    );
};
